module.exports = "/images/logo.png?14203b5024363db7d2cff5565bac4f1f";